var lists_default = {
  "fontElementMap": "Ikbzj",
  "orderedlist": "cexvV",
  "bulletedlist": "UrDHJ",
  "listItem": "GkY6Q"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
